// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__9uywA","buttons":"Footer_buttons__3uu2e"};